// Grid navigation helpers — keep the user's place after add/edit and highlight the changed row.
// The window is the scroll container (see aboo.css .content). List screens read flashId at the
// top of their list block and add class 'row-hl' to the matching row.
import { signal } from './t4.js';

export const flashId = signal(null);   // id of the row to flash-highlight

// Flash a row (call after add/edit with the returned id). Auto-clears.
export function flashRow(id){
  flashId.value = id != null ? Number(id) : null;
  const mine = flashId.value;
  setTimeout(() => { if(flashId.value === mine) flashId.value = null; }, 1800);
}

// EDIT in place: reload without losing window scroll position, then flash the row.
export async function keepScroll(reload, id){
  const y = window.scrollY;
  await reload();
  if(id != null) flashRow(id);
  requestAnimationFrame(() => requestAnimationFrame(() => window.scrollTo(0, y)));
}

// Per-screen list state so returning from a detail restores the page + scroll (not the top).
const _lists = {};
export function saveList(key, state){ _lists[key] = { ...state, scroll: window.scrollY }; }
export function takeList(key){ return _lists[key] || null; }

// ADD: reload jumping to the new row's page (reload receives the id → passes ?locate=id so the
// server returns the page holding it, even if it sorts onto another page — issue #33), flash it,
// and scroll it into view.
export async function revealRow(reload, id){
  await reload(id);
  if(id != null) flashRow(id);
  requestAnimationFrame(() => requestAnimationFrame(() => {
    const el = document.querySelector('.row-hl');
    if(el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }));
}
